import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLang } from '../i18n/LanguageContext';
import styles from './Testimonials.module.css';

// Replace these with real quotes when you have them
const QUOTES = [
  {
    id: 1,
    quote: 'Quote coming soon.',
    name: 'Name',
    title: 'Title, Company',
    visible: false,
  },
];

export default function Testimonials() {
  const revealRef = useScrollReveal();
  const { t } = useLang();
  const visible = QUOTES.filter((q) => q.visible);

  if (visible.length === 0) return null;

  return (
    <section className={styles.section} aria-label={t('testimonials.eyebrow')}>
      <div className={`container reveal ${styles.inner}`} ref={revealRef}>
        <p className="section-label">{t('testimonials.eyebrow')}</p>

        <div className={styles.grid}>
          {visible.map((q) => (
            <blockquote key={q.id} className={styles.card}>
              <p className={styles.quote}>&ldquo;{q.quote}&rdquo;</p>
              <footer className={styles.footer}>
                <span className={styles.name}>{q.name}</span>
                <span className={styles.title}>{q.title}</span>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
